import { Check } from "lucide-react";
import { Card } from "@/design/components";
import { Pill } from "@/design/components";
import { cn } from "@/design/cn";

const TIERS = [
  { tier: "Tier 1", title: "Programme setup", lines: ["Sealed (18 May)"], sealed: true, width: "max-w-sm" },
  { tier: "Tier 2", title: "Prime contractors", lines: ["3 of 4 active", "1 in onboarding"], width: "max-w-md" },
  { tier: "Tier 3", title: "Subcontractors", lines: ["7 active, 2 awaiting gate", "1 returning, 8 new"], width: "max-w-lg" },
  { tier: "Tier 4", title: "Field reporters", lines: ["23 active, 5 invited not redeemed"], width: "max-w-xl" },
];

export function CascadeVisualisation() {
  return (
    <Card>
      <div className="px-6 pt-5">
        <h3 className="text-base font-semibold tracking-tight text-ink">Onboarding cascade</h3>
        <p className="mt-0.5 text-sm text-mute">Tier 1 to Tier 4, with live counts per tier.</p>
      </div>
      <div className="flex flex-col items-center gap-2 px-6 py-6">
        {TIERS.map((t, i) => (
          <div key={t.tier} className={cn("w-full", t.width)}>
            <div className="rounded-lg border border-line bg-subtle/50 px-4 py-3">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-ink">
                  {t.tier} · {t.title}
                </span>
                {t.sealed ? (
                  <Pill variant="success" className="gap-1">
                    <Check className="h-3 w-3" /> Sealed
                  </Pill>
                ) : null}
              </div>
              <div className="mt-1 flex flex-wrap gap-x-4 text-xs text-faint">
                {t.lines.map((l) => (
                  <span key={l}>{l}</span>
                ))}
              </div>
            </div>
            {i < TIERS.length - 1 && <div className="mx-auto h-3 w-px bg-line" aria-hidden />}
          </div>
        ))}
      </div>
    </Card>
  );
}
